module.exports = __webpack_public_path__ + "img/bochiimg1.e0a78692.png";